import { render, staticRenderFns } from "./VendorLinking.vue?vue&type=template&id=a6270108&"
import script from "./VendorLinking.vue?vue&type=script&lang=js&"
export * from "./VendorLinking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports